import { cx } from './classes.js';

export interface FilterOption<K extends string> {
  key: K;
  label: string;
}

/** The Results / Alerts filter row: dark for the active choice, quiet otherwise. */
export function FilterButtons<K extends string>({
  options,
  active,
  onChange,
  label,
}: {
  options: ReadonlyArray<FilterOption<K>>;
  active: K;
  onChange: (key: K) => void;
  label: string;
}) {
  return (
    <div className="flex gap-2" role="group" aria-label={label}>
      {options.map((o) => {
        const isActive = o.key === active;
        return (
          <button
            key={o.key}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(o.key)}
            className={cx(
              'h-9 cursor-pointer rounded-btn px-3.5 text-[13px]',
              isActive
                ? 'bg-ink font-semibold text-surface'
                : 'border border-line bg-surface font-medium text-ink hover:bg-sunk',
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export function ToggleButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: string;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cx(
        'h-9 cursor-pointer rounded-btn px-3.5 text-[13px]',
        active
          ? 'bg-ink font-semibold text-surface'
          : 'border border-line bg-surface font-medium text-ink hover:bg-sunk',
      )}
    >
      {children}
    </button>
  );
}
